import { FrekuentLogoFull } from '../../icons';
import FrekuentLogo from '../../icons/FrekuentLogo';

type SidebarLogoProps = {
	collapsed?: boolean;
};

const SidebarLogo = ({ collapsed }: SidebarLogoProps) => {
	return (
		<>
			<span className='block'>{collapsed ? <FrekuentLogo /> : <FrekuentLogoFull />}</span>
		</>
	);
};

export default SidebarLogo;
